import { createContext, useContext } from 'react';

export type Language = 'de' | 'en' | 'fr';

export const LanguageContext = createContext<Language>('en');

export function useLanguage(): Language {
  return useContext(LanguageContext);
}
